// extracted by mini-css-extract-plugin
export default {"container":"footer-module__container__GfGG7","mobileContainer":"footer-module__mobileContainer__ESeCq","linksContainer":"footer-module__linksContainer__bnUz+"};